// extracted by mini-css-extract-plugin
module.exports = {"base":"Button_base__ZU5RD","white":"Button_white__IO5O_","green":"Button_green__D_kBN","red":"Button_red__jectV"};